import fp from 'lodash/fp';
import React from 'react';
import {
  setDisplayName,
  wrapDisplayName
} from 'recompose';

const followedBy = fp.curry(
  (key, components) => (
    (Component) => {
      const FollowedBy = (
        ({
          children,
          ...props
        }) => fp.concat([
          <Component {...{ key, ...props }}>
            {children}
          </Component>
        ])(
          fp.isFunction(components) ?
            components(props) :
            components
        )
      );

      return (
        process.env.NODE_ENV !== 'production' ?
          setDisplayName(wrapDisplayName(Component, 'followedBy')) :
          fp.identity
      )(FollowedBy);
    }
  )
);

export default followedBy;



// WEBPACK FOOTER //
// ./src/containers/components/higher-order/followed-by.js